<template>
  <div>
    <header id="header" class="header-section header-section3 container-fluid no-padding" style="background-color: #2b2b2b ">
      <!-- nav -->
      <nav class="navbar navbar-default ow-navigation">
        <div class="navbar-header">
          <button aria-controls="navbar" aria-expanded="false" data-target="#navbar" data-toggle="collapse" class="navbar-toggle collapsed" type="button">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a v-on:click="menuClick('main-home')"  class="navbar-brand"><img src="static/images/logo_renasoftware.png" alt="Logo" ></a>
        </div>
        <div class="navbar-collapse collapse navbar-right" id="navbar">
          <ul class="nav navbar-nav navbar-right ">
            <li class="active">
              <a v-on:click="menuClick('main-home')">메인홈</a>
            </li>
            <li>
              <a v-on:click="menuClick('service')">회사소개</a>
            <!--<li class="dropdown mega-dropdown">-->
              <!--<a v-on:click="menuClick('service')" class="dropdown-toggle" role="button" aria-haspopup="true" aria-controls="navbar" aria-expanded="false" data-target="#navbar" data-toggle="collapse">회사소개</a>-->
              <!--<i class="ddl-switch fa fa-angle-down"></i>-->
              <!--<ul class="dropdown-menu mega-menu company" role="menu">-->
                <!--<li>-->
                  <!--<div class="dropdown-box col-md-3">-->
                    <!--<ul>-->
                      <!--&lt;!&ndash;-->
                      <!--<li><a href="service.html#service-about">About</a></li>-->
                      <!--<li><a href="service.html#service-business" >Business</a></li>-->
                      <!--<li><a href="service.html#service-history">History</a></li>-->
                      <!--<li><a href="$">Conatact us</a></li>&ndash;&gt;-->

                      <!--<li><a v-on:click="menuClick('service-about')">About</a></li>-->
                      <!--<li><a v-on:click="menuClick('service-business')">Business</a></li>-->
                      <!--<li><a v-on:click="menuClick('service-history')">History</a></li>-->
                    <!--</ul>-->
                  <!--</div>-->
                <!--</li>-->
              <!--</ul>-->
            <!--</li>-->
            <li>
              <a v-on:click="menuClick('portfolio')">개발서비스</a>
            </li>
            <li>
              <a v-on:click="menuClick('blog')">블로그</a>
            </li>
            <li>
              <a v-on:click="menuClick('contact')">개발 견적 문의</a>
            </li>
          </ul>
          <ul class="nav navbar-nav navbar-right">
            <li class="active">
              <a v-on:click="menuClick('main-home')" aria-controls="navbar" aria-expanded="false" data-target="#navbar" data-toggle="collapse">메인홈</a>
            </li>
            <li>
              <a v-on:click="menuClick('service')" aria-controls="navbar" aria-expanded="false" data-target="#navbar" data-toggle="collapse">회사소개</a>
            <li>
              <a v-on:click="menuClick('portfolio')" aria-controls="navbar" aria-expanded="false" data-target="#navbar" data-toggle="collapse">개발서비스</a>
            </li>
            <li>
              <a v-on:click="menuClick('blog')" aria-controls="navbar" aria-expanded="false" data-target="#navbar" data-toggle="collapse">블로그</a>
            </li>
            <li>
              <a v-on:click="menuClick('contact')" aria-controls="navbar" aria-expanded="false" data-target="#navbar" data-toggle="collapse">개발 견적 문의</a>
            </li>
          </ul>

        </div><!--/.nav-collapse -->
      </nav><!-- nav /- -->
    </header><!-- Header Section /- -->
  </div>
</template>

<script>
  export default {
    name: 'TopMenu',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods: {
      menuClick(title) {
        console.log('## click menu x: ' + title)
        //this.menuVisible = false
        this.$emit('clicked',title)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TopMenu.vue